export async function getEDITransactionCodes() {
  const response = await fetch('/edi-transaction-codes.json')
  const data = await response.json()
  return data
}

export async function getEDIFactCodes() {
  const response = await fetch('/edi-fact-codes.json')
  const data = await response.json()
  return data
}
